
(function ($) {
  const ps5_pre_order_out_of_stock = window.theme.ps5_pre_order_out_of_stock;
  const ps5_pre_order_err_quantity = window.theme.ps5_pre_order_err_quantity;
  const ps5_pre_order_limit_product_ids = window.theme.ps5_pre_order_limit_product_ids;
  const ps5_pre_order_limit_product_qty = window.theme.ps5_pre_order_limit_product_qty;
  const ps5_product_not_pre_order = window.theme.ps5_product_not_pre_order;
  const ps5InputValidate = $('input[name="ps5_validate"]');
  let validatePs5 = false;
  let countProductPreOrder = 0;
  let countProductNotPreOrder = 0;
  let countProductCart = 0;
  let arrProductPreOrder = [];

  $(document).ready(function () {
    const btnContinue = $('.cart__checkout-button.button');;
    const ele_loading_cover = $('#cover-spin');

    if ($('.cart.template-cart').length) {
      ajaxCart();
      btnContinue.on('click', function (event) {
        console.log(validatePs5, countProductPreOrder, countProductNotPreOrder, countProductCart, arrProductPreOrder);
        let preventCheckout = false;
        ps5InputValidate.val(false);
        if ((validatePs5 && countProductCart > 1) || (validatePs5 && (countProductPreOrder > ps5_pre_order_limit_product_qty))) {
          preventCheckout = true;
          ps5InputValidate.val(true);
        }
        if (preventCheckout) {
          event.preventDefault();
          alert(ps5_pre_order_out_of_stock);
        }
      })

    }

    /**
     * get product in cart
     * @param val true/false
     * true: pre order
     * false: ps5 + pre order
     */
    function ajaxCart() {
      ele_loading_cover.addClass('active');
      $.ajax({
        type: 'GET',
        url: '/cart.js',
        cache: false,
        dataType: 'json',
        success: function (cart) {
          ele_loading_cover.removeClass('active');
          countProductCart = cart.item_count;
          if (cart.item_count > 0) {
            cart.items.forEach(item => {

              // check product id in config
              if (ps5_pre_order_limit_product_ids != "") {
                if (ps5_pre_order_limit_product_ids.search(item.product_id + "") > -1) {
                  if (arrProductPreOrder.indexOf(item.product_id) === -1) {
                    countProductPreOrder += item.quantity;
                    arrProductPreOrder.push(item.product_id);
                  }
                  if (parseInt(item.quantity) > parseInt(ps5_pre_order_limit_product_qty)) {
                    validatePs5 = true;
                    const eleError_Msg = $(`.cart-item[data-product-id="${item.product_id}"]`).find('.error_Msg.not_update');
                    eleError_Msg.css('display', 'block');
                    eleError_Msg.text(ps5_pre_order_err_quantity);
                  }
                }
              }

              // check pre order tags
              ajaxProduct(item);
            })

          } else {
            handleBtnContinue(false);
            ele_loading_cover.removeClass('active');
          }
        }
      })
    }

    // ajax get attr product
    function ajaxProduct(item) {
      $.ajax({
        type: 'GET',
        url: `/products/${item.handle}.json`,
        cache: false,
        dataType: 'json',
        success: function (data) {
          handleCheckTagPreOrder(item, data.product)
        }
      })
    }

    /**
     * handle btn continue
     * @param val
     */
    function handleBtnContinue(val) {
      btnContinue.prop("disabled", val) // false => Enable true => Disable
    }

    /**
     * check tag pre order
     * @param tags
     */
    function handleCheckTagPreOrder(item_product, product) {
      const tags = product.tags;
      const arrTags = tags.split(',');
      if (ps5_pre_order_limit_product_ids.search(item_product.product_id + "") === -1) {
        $(`.cart-item[data-product-id="${product.id}"]`).addClass('not_pre_order');
      }
      countProductNotPreOrder += 1;
      let i;
      for (i = 0; i < arrTags.length; i++) {
        const item = arrTags[i];
        if (item.includes('__label')) {
          const label_name = item.replace('__label:', '');
          const label_name_lower = label_name.trim().toLowerCase();
          if (label_name_lower == "pre order" || label_name_lower == "đặt hàng trước" || label_name_lower == "combo mới") {
            validatePs5 = true;
            if (arrProductPreOrder.indexOf(item_product.product_id) === -1) {
              arrProductPreOrder.push(item_product.product_id);
              countProductPreOrder += item_product.quantity;
            }
            $(`.cart-item[data-product-id="${product.id}"]`).removeClass('not_pre_order').addClass('pre_order');
            countProductNotPreOrder -= 1;
          }
        }
      }
      showTextSuggestion();
    }

    /**
     * show text suggestion remove
     */
    function showTextSuggestion() {
      if ((validatePs5 && arrProductPreOrder.length > 0) || (arrProductPreOrder.length > 0 && countProductCart > 1)) {
        $('.cart-item.not_pre_order').find('.error_Msg.not_update').css('display', 'block').text(ps5_product_not_pre_order).removeClass('not_update');
      }
    }
  })
}(jQuery));
